import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/events/raps-global-regulatory-strategy-conference-2025")({
  head: () => buildRouteHead("/en/events/raps-global-regulatory-strategy-conference-2025", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/events", replace: true });
  },
});
